function ucFirst(str) {
  if (!str) return str;
  return str[0].toUpperCase() + str.slice(1);
}

function getOrganizationName(organizationName) {
  return organizationName ? ucFirst(organizationName.split('.')[0]) : 'company';
}

export function getInviterDecorator(inviter) {
  const organizationName = getOrganizationName(inviter.organization.name);
  const inviterName = inviter.fullName || 'Your friend';
  const membersCount = inviter.organization.membersCount;
  return {
    inviterName,
    membersCount,
    organizationName,
    inviterAvatar: inviter.avatar,
    domainsThatCanJoin: inviter.organization.domainsThatCanJoin,
  };
}
